// 2026-10-26 — FIRST: the two built-ins an older phone's browser lacks (polyfills.ts says which, and the iPhone it was measured on)
import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import "react-loading-skeleton/dist/skeleton.css";

import reportWebVitals from "./reportWebVitals";

import App from "./App";
import { installErrorHandlers } from "./beacon";
import { installStaleScriptReload } from "./stale-script-reload";
import { readInternalFromUrl } from "./internal";
import { readTryFromUrl } from "./try";

// TW-0132 — a JS crash on a client's phone used to die on their screen and reach nobody. FIRST,
// and at module load: a crash while the bundle is still booting happens before React exists, which
// is precisely the crash the error boundary in App.tsx cannot see, and everything below this line
// is code that can throw.
installErrorHandlers();
// TW-0622 — a deploy must not break a form that is already open: a file of ours that fails to load reloads the page once
// (stale-script-reload.ts). Listeners ADDED beside the beacon's, never replacing them; neither stops the other hearing an error.
installStaleScriptReload();
// TW-0064 — `?wt_internal=1` on any form URL marks THIS BROWSER as ours, so a test signing from it
// is not counted as one of the shop's clients. Read here rather than in a screen: it is the first
// thing that runs, it covers every route, and it costs one URLSearchParams read on a page whose
// paint speed is the product (`internal.ts` says why the form needed its own).
readInternalFromUrl();
// the owner trying their own form from the app's QR screen (`?wt_try=1`, try.ts): read once, kept for
// this tab, so the done screen can show the way back instead of the client's dead end
readTryFromUrl();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
